module.exports = ".cursor {\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/_summary-detail/summary-detail.component.css
// module id = ./src/app/sendMoney/_summary-detail/summary-detail.component.css
// module chunks = main